module.exports = __webpack_public_path__ + "static/media/faceberk-vector.04a6275b.svg";